import { createFileRoute, notFound } from "@tanstack/react-router";
import { MarketingIntegrationsPage } from "../components/marketing/MarketingIntegrationsPage";
import { contentHead } from "../marketing-content/head";
import {
  findIntegrationCategory,
  integrationCategoryPage,
} from "../marketing-content/integrations";

export const Route = createFileRoute("/integrations_/category/$category")({
  loader: ({ params }) => {
    const category = findIntegrationCategory(params.category);
    if (!category) throw notFound();
    return category;
  },
  head: ({ loaderData }) => contentHead(loaderData && integrationCategoryPage(loaderData)),
  component: CategoryRoute,
});

function CategoryRoute() {
  const category = Route.useLoaderData();
  return <MarketingIntegrationsPage category={category} key={category.slug} />;
}
